export enum RfiStatus {
    DRAFT = "1",
    SEARCH_IN_PROGRESS = "2",
    SEARCH_COMPLETE = "3",
    CANCELED = "4",
}